{
	"title": "Redefinir senha",
	"labels": {
		"company": "Empresa",
		"password": "Senha",
		"confirmPassword": "Confirmar senha"
	},
	"fields": {
		"organization": {
			"placeholder": "Insira a empresa",
			"required": "A empresa é obrigatória"
		},
		"password": {
			"placeholder": "Insira sua senha",
			"required": "A senha é obrigatória",
			"invalid": "Senha inválida"
		},
		"confirmPassword": {
			"placeholder": "Confirme sua senha",
			"required": "A confirmação de senha é obrigatória",
			"invalid": "A confirmação de senha é inválida"
		},
		"errors": {
			"required": "O campo é obrigatório",
			"passwordMustBeSame": "A senha e a confirmação de senha devem ser iguais",
			"tokenRequired": "O token é obrigatório",
			"organizationRequired": "A organização é obrigatória"
		}
	},
	"submit": "Salvar nova senha",
	"successModal": {
		"title": "A nova senha foi salva com sucesso!",
		"subtitle": "Agora é só acessar o Dashboard Zig com a sua nova senha.",
		"btnTitle": "Fazer Login"
	},
	"passwordRules": {
		"minLength": "Mínimo de 8 caracteres",
		"uppercase": "Pelo menos 1 letra maiúscula",
		"lowercase": "Pelo menos 1 letra minúscula",
		"number": "Pelo menos 1 número",
		"special": "Pelo menos 1 caractere especial (!@#$...)"
	},
	"passwordRuleState": {
		"passed": "atendido",
		"failed": "não atendido"
	},
	"passwordStrength": {
		"weak": "Fraca",
		"fair": "Razoável",
		"strong": "Forte",
		"veryStrong": "Muito forte",
		"ariaLabel": "Força da senha: {{level}}"
	},
	"passwordMatch": {
		"mismatch": "As senhas não conferem"
	}
}
